<template>
  <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'">
          <el-form-item label="日期" prop="currentData">
          <el-input v-model="dataForm.currentData" placeholder="日期"></el-input>
      </el-form-item>
          <el-form-item label="渠道ID" prop="channelId">
          <el-input v-model="dataForm.channelId" placeholder="渠道ID"></el-input>
      </el-form-item>
          <el-form-item label="渠道名称" prop="channelName">
          <el-input v-model="dataForm.channelName" placeholder="渠道名称"></el-input>
      </el-form-item>
          <el-form-item label="渠道ID" prop="productId">
          <el-input v-model="dataForm.productId" placeholder="渠道ID"></el-input>
      </el-form-item>
          <el-form-item label="渠道名称" prop="productName">
          <el-input v-model="dataForm.productName" placeholder="渠道名称"></el-input>
      </el-form-item>
          <el-form-item label="类型" prop="type">
          <el-input v-model="dataForm.type" placeholder="类型"></el-input>
      </el-form-item>
          <el-form-item label="撞库总数" prop="totalCheckCount">
          <el-input v-model="dataForm.totalCheckCount" placeholder="撞库总数"></el-input>
      </el-form-item>
          <el-form-item label="撞库失败数" prop="failedCheckCount">
          <el-input v-model="dataForm.failedCheckCount" placeholder="撞库失败数"></el-input>
      </el-form-item>
          <el-form-item label="撞库成功数" prop="successCheckCount">
          <el-input v-model="dataForm.successCheckCount" placeholder="撞库成功数"></el-input>
      </el-form-item>
          <el-form-item label="进件总数" prop="totalPushCount">
          <el-input v-model="dataForm.totalPushCount" placeholder="进件总数"></el-input>
      </el-form-item>
          <el-form-item label="进件成功数" prop="successPushCount">
          <el-input v-model="dataForm.successPushCount" placeholder="进件成功数"></el-input>
      </el-form-item>
          <el-form-item label="推送成功数" prop="successPushReplyCount">
          <el-input v-model="dataForm.successPushReplyCount" placeholder="推送成功数"></el-input>
      </el-form-item>
          <el-form-item label="撞库成功率" prop="checkSuccessRate">
          <el-input v-model="dataForm.checkSuccessRate" placeholder="撞库成功率"></el-input>
      </el-form-item>
          <el-form-item label="进件率" prop="pushRate">
          <el-input v-model="dataForm.pushRate" placeholder="进件率"></el-input>
      </el-form-item>
          <el-form-item label="进件成功率" prop="pushSuccessRate">
          <el-input v-model="dataForm.pushSuccessRate" placeholder="进件成功率"></el-input>
      </el-form-item>
          <el-form-item label="推送成功率" prop="pushSuccessReplyRate">
          <el-input v-model="dataForm.pushSuccessReplyRate" placeholder="推送成功率"></el-input>
      </el-form-item>
              <el-form-item label="更新人" prop="updateBy">
          <el-input v-model="dataForm.updateBy" placeholder="更新人"></el-input>
      </el-form-item>
          <el-form-item label="更新日期" prop="updateTime">
          <el-input v-model="dataForm.updateTime" placeholder="更新日期"></el-input>
      </el-form-item>
          <el-form-item label="删除日期" prop="deleteTime">
          <el-input v-model="dataForm.deleteTime" placeholder="删除日期"></el-input>
      </el-form-item>
      </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
  data () {
    return {
      visible: false,
      dataForm: {
        id: '',
        currentData: '',
        channelId: '',
        channelName: '',
        productId: '',
        productName: '',
        type: '',
        totalCheckCount: '',
        failedCheckCount: '',
        successCheckCount: '',
        totalPushCount: '',
        successPushCount: '',
        successPushReplyCount: '',
        checkSuccessRate: '',
        pushRate: '',
        pushSuccessRate: '',
        pushSuccessReplyRate: '',
        creator: '',
        createDate: '',
        updateBy: '',
        updateTime: '',
        deleteTime: ''
      }
    }
  },
  computed: {
    dataRule () {
      return {
        currentData: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        channelId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        channelName: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        productId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        productName: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        type: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        totalCheckCount: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        failedCheckCount: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        successCheckCount: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        totalPushCount: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        successPushCount: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        successPushReplyCount: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        checkSuccessRate: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        pushRate: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        pushSuccessRate: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        pushSuccessReplyRate: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        updateBy: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        updateTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        deleteTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    },
    // 获取信息
    getInfo () {
      this.$http.get(`/sys/apiproductreport/${this.dataForm.id}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
      }).catch(() => {})
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.$http[!this.dataForm.id ? 'post' : 'put']('/sys/apiproductreport/', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>
